import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScheduleJobModalPopupComponent } from '../schedule-job-modal-popup/schedule-job-modal-popup.component';

@Component({
  selector: 'app-schedule-job',
  templateUrl: './schedule-job.component.html',
  styleUrls: ['./schedule-job.component.scss']
})
export class ScheduleJobComponent implements OnInit {
  nameofTask: any
  paramIdDelete: any
  paramNameDelete: any
  valueDelete: any
  taskIdDelete: any
  viewRun: any = [];
  allTask: any
  allScheduleTask: any
  eventId: any
  updateIndex:any
  taskJobId: any
  updatePattern: any
  updateServer: any
  taskScheduledId: any
  taskId: any
  taskName: any
  userName: any
  userName1: any
  enable: boolean = true
  eventDate: any
  timeInUk: any
  timeInEdtEst: any
  status: any
  scheduleTaskId1: any;
  serverName: any
  message: any
  viewEvent: boolean = false
  dataEvent: any
  viewScheduleUpdate: any
  addSchedule1: any
  idAdd: any
  idAdd1: any
  taskNameAdd: any;
  id1: any
  viewJobIdData: any = []
  updateBar: any = []
  addTaskName: any = []
  currentDate = new Date();
  todayDate: any


  server: any
  pattern: any
  dropDown: any
  dropDown1: any
  scheduleUpdate: boolean = false
  scheduleAdd: boolean = false
  taskAddError: boolean = false
  viewObj: any;
  viewObj1: any;
  scheduleTaskIdUpdate: any
  taskIdUpdate: any
  taskIdAdd: any
  taskAddId: any
  taskNameUpdate: any
  serverNameUpdate: any
  errorMsg: boolean = false
  taskParameterId: any;
  paramName: any;
  parameterArray :any=[]
  value: any;
  taskId1: any;
  task: boolean = false;
  errMsg: boolean = false;
  errMsg1: boolean = false;
  scheduled: boolean = false;
  onLoad: boolean = false;
  view: boolean = false;
  show: boolean = false;
  showDetails: any;
  indexArray: any = [];
  id = 2;
  param: boolean = false;
  paramShow: boolean = true;
  paramHide: boolean = false;
  option: any;
  task1: boolean = false;
  test: any;
  viewtaskScheduledId: any
  viewtaskJobId: any
  viewtaskId: any
  viewtaskName: any
  viewstatus: any
  viewstartDate: any
  viewendDate: any
  viewByEventId_EventId: any
  viewByEventId_JobId: any
  viewByEventId_ScheduleId: any
  viewByEventId_Id: any
  viewByEventId_taskName: any
  viewByEventId_user: any
  viewByEventId_timeUk: any
  viewByEventId_timeEst_Edt: any
  viewByEventId_status: any
  viewByEventId_server: any
  viewByEventId_message: any
  viewEventIdData: any = []
  parameterValue: any
  tokenDetails: any;
  disableTask = false
  public isShowVariantDetails = false;
  hiddenitems: boolean = false
  indexValue: any
  showArray: any = []
  hideArray: any = []
  taskIdArray: any = []
  arrayLength: any
  showText: any
  hideText: any = "Show"
  prevIndex: any


  constructor(private service: ApifirstService, private translate:TranslateService,public datePipe:DatePipe, private modalService: NgbModal,) { }

  ngOnInit(): void {
    this.onLoad = true;
    this.service.userId.subscribe((data) => {
      this.userName1 = data;
    })

    this.service.getAllTask().subscribe(data => {
      this.allTask = data
      for (let i of this.valu) {
        if (this.allTask.length == 0) {
          i.disabled = false
        }
        for (let j of this.allTask) {
          if (j.taskClassSimpleName == i.name) {

            i.disabled = true
          }
          else
            i.disabled = false
        }
      }
    })

  }

  openPopUp() {
    const modalRef = this.modalService.open(ScheduleJobModalPopupComponent, { windowClass : "myCustomModalClass"});
     modalRef.result.then(
         result => {
             console.log(result);
         },
         reason => {}
     );
  }

  taskNameData = [
    {
      "id": 1,
      "name": "FastRuleProcessing"
    },
    {
      "id": 2,
      "name": "FastDeliverableProcedureMappingTask"
    },
    {
      "id": 3,
      "name": "RegenerateRulesTask"
    }
  ]
  valu = [
    {
      "id": 1,
      "name": "FastRuleProcessing",
      "disabled": false
    },
    {
      "id": 2,
      "name": "FastDeliverableProcedureMappingTask",
      "disabled": false
    },
    {
      "id": 3,
      "name": "RegenerateRulesTask",
      "disabled": false
    }
  ]
  statusData = [
    {
      "id": 1,
      "name": "TASK_LAUNCHED"
    },
    {
      "id": 2,
      "name": "TASK_SCHEDULED"
    },
    {
      "id": 3,
      "name": "STARTED"
    },
    {
      "id": 4,
      "name": "ERROR"
    },
    {
      "id": 5,
      "name": "FINISHED"
    },
    {
      "id": 6,
      "name": "ALREADY_RUNNING"
    }
  ]


  taskClick() {
    this.task = true;
    this.onLoad = false;
    this.scheduled = false;
    this.view = false;
    this.show = true;
    this.viewEvent = false
    this.scheduleUpdate = false;
    this.scheduleAdd = false;
    this.dropDown1 = ""
    this.taskAddError==false
    this.service.tokenObj.subscribe((data) => {
      this.tokenDetails = data
    })
    this.getTask();
    this.service.getAllTask().subscribe(data => {
      this.allTask = data


      for (let i of this.valu) {

        if (this.allTask.length == 0) {
          i.disabled = false
          break;

        } else {
          for (let j of this.allTask) {
            if (j.taskClassSimpleName == i.name) {


              i.disabled = true
              break;
            }
            else
              i.disabled = false
          }
        }
      }
    })
  }
  scheduledClick() {
    this.task = false;
    this.onLoad = false;
    this.scheduled = true;
    this.view = false;
    this.show = true;
    this.viewEvent = false
    this.scheduleUpdate = false;
    this.scheduleAdd = false;
    this.server = ""
    this.pattern = ""
    this.dropDown = ""
    this.viewObj = ""
    this.errMsg = false
    this.errMsg1 = false
    this.getTask();
    this.service.getAllScheduleTask().subscribe(data => {
      this.allScheduleTask = data
      this.service.getTaskName().subscribe(
        data => {
          this.addTaskName = data

          for (let i of this.addTaskName) {

            if (this.allScheduleTask.length == 0) {
              i.disabled = false
              break;
            } else {
              for (let j of this.allScheduleTask) {
                if (j.taskId == i.taskId) {
                  i.disabled = true
                  break;
                }
                else
                  i.disabled = false

              }
            }
          }
        })

    })
  }
  getTask() {
    this.service.getTaskName().subscribe(
      data => {
        this.addTaskName = data

      })
  }
  taskSelect(id: any) {
    this.idAdd = id;
    this.viewObj = this.addTaskName.filter((data: any) => {
      return data.taskId == this.idAdd
    })

  }
  viewClick() {
    this.task = false;
    this.onLoad = false;
    this.scheduled = false;
    this.view = true;
    this.show = false;
    this.viewEvent = false
    this.scheduleUpdate = false;
    this.scheduleAdd = false;
    this.viewstartDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd')
    this.viewRun = []
    this.viewtaskScheduledId = ""
    this.viewtaskJobId = ""
    this.viewtaskId = ""
    this.viewtaskName = ""
    this.viewendDate = ""
    this.viewstatus = null
    if (this.viewRun.length == 0) {
      this.errorMsg = true
    }
  }
  viewRunSubmit() {

  }
 
  getAllTask() {
    this.service.getAllTask().subscribe(data => {
      this.allTask = data


    })
  }
  scheduleGetCall() {
    const request = {
      "name": this.taskNameAdd,
      "taskId": this.taskIdAdd
    }
    if (this.errMsg == false) {
      this.service.getschedulecall(request).subscribe(data => {
      })
      this.service.getAllScheduleTask().subscribe(data => {
        this.allScheduleTask = data})
    }
  }
  runTask(id: any, name: any) {
    this.updateBar = true
    var item
    item = document.getElementById(id);
    if (item) item.style.display = '';
      const request = {
        "taskScheduledId": 0,
        "taskId": id,
        "userId": this.userName1,
        "languageCode": this.tokenDetails.language,
        "countryCode": this.tokenDetails.country
      }
      if (name == "RegenerateRulesTask") {
        this.service.runTask1(request).subscribe(data => {
        this.service.scheduleJobStatusMessage.next(data.status);
        this.openPopUp();
          var item
          item = document.getElementById(id);
          if (item) item.style.display = 'none'
        });
      }
      else if (name == "FastRuleProcessing")
        this.service.runTask(request).subscribe(data => {
        this.service.scheduleJobStatusMessage.next(data.status);
        this.openPopUp();
          var item
          item = document.getElementById(id);
          if (item) item.style.display = 'none'
        });
      else if (name == "FastDeliverableProcedureMappingTask")
        this.service.runTask2(request).subscribe(data => {
        this.service.scheduleJobStatusMessage.next(data.status);
        this.openPopUp();
          var item
          item = document.getElementById(id);
          if (item) item.style.display = 'none'
        });
  }
  deleteTaskParameter() {
    const request = {
      "taskParameterId": this.paramIdDelete,
      "parameterName": this.paramNameDelete,
      "value": this.valueDelete,
      "taskId": this.taskIdDelete
    }

    this.service.deleteTaskParameter(request).subscribe(data => {
      this.service.getTaskParameter(this.taskIdDelete).subscribe((data) => {
        this.showDetails = data
      this.parameterArray=[]
      for (let i of this.showDetails) {
        this.parameterArray.push(i.value)
          if (i.parameterName == 'GenerateQueue')
            i.defaultValue = "false";
          if (i.parameterName == 'RegenerateTestRules')
            i.defaultValue = "false";
        }
      }
      )
    })
  }
  updateTask() {
    const req = {
      "taskParameterId": this.taskParameterId,
      "parameterName": this.paramName,
      "value": this.parameterArray[this.updateIndex],
      "taskId": this.taskId1
    }
    
    this.service.updateTaskParameter(req).subscribe(data => { 
    })


    this.getTaskParameter(this.taskId1)
    this.service.getTaskParameter(this.taskId1).subscribe((data) => {
      this.showDetails = data
      this.parameterArray=[]
      for (let i of this.showDetails) {
        this.parameterArray.push(i.value)
        if (i.parameterName == 'GenerateQueue')
          i.defaultValue = "false";
        if (i.parameterName == 'RegenerateTestRules')
          i.defaultValue = "false";
      }
    })

  }
  getTaskParameter(id:any)
  {
    this.service.getTaskParameter(id).subscribe((data) => {
      this.showDetails = data
      this.parameterArray=[]
      for (let i of this.showDetails) {
        this.parameterArray.push(i.value)
        if (i.parameterName == 'GenerateQueue')
          i.defaultValue = "false";
        if (i.parameterName == 'RegenerateTestRules')
          i.defaultValue = "false";
      }
    })
  }
  taskSelect1(id1: any) {
    this.idAdd1 = id1;

    this.viewObj1 = this.valu.filter((data: any) => {
      return data.id == this.idAdd1
    })



  }
  addTask() {
    this.taskAddError==false
    if (this.dropDown1 == undefined || this.dropDown1 == "") {
      alert(this.translate.instant('taskSelect'));

    }
    else {
      this.task1 = true;

      const request = {
        "taskId": this.viewObj1[0].id,
        "taskClassSimpleName": this.viewObj1[0].name,
        "userId": this.userName1,
        "markedAsDeleted": false,
        "queued": false
      }
      this.service.getTaskName().subscribe(
        data => {
          this.addTaskName = data
          for (let i of this.addTaskName) {
            if(i.taskClassSimpleName==this.viewObj1[0].name){
            this.taskAddError=true
              break;
          }
            else
            this.taskAddError=false
          }
          if(this.taskAddError==false){
            this.service.addTask(request).subscribe(data => { })
      
              }
              this.service.getTaskName().subscribe(
                data => {
                  this.addTaskName = data
                  for (let i of this.addTaskName) {
                    if(i.taskClassSimpleName==this.viewObj1[0].name){
                      this.indexValue = this.allTask.findIndex((x: any) => x.taskId === i.taskId)

                      this.showHideButton(i.taskId, this.indexValue)
                      break;
                    }}
                })
             
        })
    }

    this.taskClick()
  }
  arr: any = []
  selected() {
    for (let t of this.valu) {
      if (t.id == this.option) {
        this.test = t.name
      }
    }
    this.arr = [{
      "id": this.option,
      "name": this.test
    }]

  }
  deleteTask(task: any) {

    const request = {
      "taskId": task.taskId,
      "taskClassSimpleName": task.taskName,
      "markedAsDeleted": false,
      "queued": false
    }

    this.service.deleteTask(request).subscribe(data => { })

    this.service.getAllTask().subscribe(data => {
      this.allTask = data


      for (let i of this.valu) {

        if (this.allTask.length == 0) {
          i.disabled = false


        } else {
          for (let j of this.allTask) {
            if (j.taskClassSimpleName == i.name) {

              i.disabled = true
            }
            else
              i.disabled = false
          }
        }
      }
    })
    this.taskClick();
  }



  updateform(taskParameterId: any, parameterName: any, value: any, taskId: any,j:any) {
    this.taskParameterId = taskParameterId;
    this.paramName = parameterName;
    this.taskId1 = taskId;
    this.updateIndex=j

    this.updateTask()
  }
  valueChange(v: any) {
    this.value = v.target.value;

  }
  deleteForm(taskParameterId: any, parameterName: any, value: any, taskId: any) {
    this.paramIdDelete = taskParameterId;
    this.paramNameDelete = parameterName;
    this.valueDelete = null;
    this.taskIdDelete = taskId
    this.deleteTaskParameter()
  }

  viewRunHistory() {
    const request = {
      "command": "search",
      "taskScheduledId": this.viewtaskScheduledId,
      "taskJobId": this.viewtaskJobId,
      "taskId": this.viewtaskId,
      "taskName": this.viewtaskName,
      "status": this.viewstatus,
      "startDate": this.datePipe.transform(this.viewstartDate, 'yyyy-MM-dd'),
      "endDate": this.datePipe.transform(this.viewendDate, 'yyyy-MM-dd'),
      "eventId": 0
    }
    this.service.viewRunHistory(request).subscribe((data) => {
      this.viewRun = data
      if (this.viewRun.length == 0) {
        this.errorMsg = true
      }
      else {
        this.errorMsg = false
      }
    })
    this.viewRunSubmit()

  }

  navigate(id: any, name: any) {
    this.taskClick()

    this.service.getAllTask().subscribe(data => {
      this.allTask = data
      this.arrayLength = this.allTask.length

      this.indexValue = this.allTask.findIndex((x: any) => x.taskId === id)

      this.showHideButton(id, this.indexValue)

    })
  }





  showHideButton(id: any, index1: any) {
    this.indexValue = index1
    this.service.getAllTask().subscribe(data => {
      this.allTask = data
      for (let i in this.allTask) {
        this.showArray.push(false)
      }
      if (this.taskIdArray.includes(id)) {
        this.taskIdArray = this.taskIdArray.filter((data: any) => {
          return data != id
        })
        this.prevIndex = this.indexValue
        for (let i in this.showArray) {
          if (i != this.indexValue) {
            this.showArray[i] = false
          }
        }
        this.showArray[this.indexValue] = !this.showArray[this.indexValue]

      }
      else {
        this.taskIdArray.push(id)
        for (let i in this.allTask) {
          this.showArray.push(false)
        }
        this.showArray[this.indexValue] = true
        for (let i in this.showArray) {
          if (i != this.indexValue) {
            this.showArray[i] = false
          }
        }
      }
    })


    this.service.getTaskParameter(id).subscribe((data) => {
      this.showDetails = data
      this.parameterArray=[]
      for (let i of this.showDetails) {
        this.parameterArray.push(i.value)
        if (i.parameterName == 'GenerateQueue')
          i.defaultValue = "false";
        if (i.parameterName == 'RegenerateTestRules')
          i.defaultValue = "false";
      }



    }
    )
  }
  
  viewBasedOnEventId(eventId: any, taskJobId: any, taskScheduledId: any, taskId: any,
    taskName: any, userName: any, timeInUK: any, timeInEdtEst: any, status: any, serverName: any, message: any, eventDate: any) {
    this.viewEvent = true
    this.task = false;


    this.scheduled = false;
    this.view = false;
    this.show = false;

    this.eventId = eventId,
      this.taskJobId = taskJobId,
      this.taskScheduledId = taskScheduledId,
      this.taskId = taskId,
      this.taskName = taskName,
      this.userName = userName,
      this.eventDate = eventDate,
      this.timeInUk = timeInUK,

      this.timeInEdtEst = timeInEdtEst,
      this.status = status,
      this.serverName = serverName
    for (let l of this.viewRun)
      this.message = message

    this.dataBasedOnEventId()

  }
  navigateSchedule(schedule: any, taskId: any, taskName: any) {
    if(schedule != 0){
    this.scheduleTaskIdUpdate = ""
    this.taskIdAdd = ""
    this.taskNameAdd = ""
    this.updatePattern = ""
    this.serverNameUpdate = ""
    this.scheduleTaskIdUpdate = schedule
    this.taskIdAdd = taskId
    this.taskNameAdd = taskName
    this.scheduleUpdate = true;
    this.viewEvent = false;
    this.task = false;
    this.scheduled = false;
    this.view = false;
    this.show = false;
    const request = {
      "command": "drillByScheduledTaskId",
      "taskScheduledId": this.scheduleTaskIdUpdate

    }

    this.service.viewRunHistory(request).subscribe((data) => {

      this.taskIdAdd = data[0].taskId;
      this.taskNameAdd = data[0].taskName
      this.updatePattern = data[0].pattern
      this.serverNameUpdate = data[0].serverName

      this.scheduleUpdateSubmit()

    })
    this.scheduleUpdateSubmit()
  }
  }
  drillByScheduleId() {
    this.dataEvent = [{
      "eventId": this.eventId,
      "taskJobId": this.taskJobId,
      "taskId": this.taskId,
      "taskScheduledId": this.taskScheduledId,
      "taskName": this.taskName,
      "userId": this.userName,
      "status": this.status,
      "serverName": this.serverName,
      "eventDate": this.eventDate,
      "message": this.message,
      "userName": this.userName,
      "timeInUK": this.timeInUk,
      "timeInEdtEst": this.timeInEdtEst,
    }]

  }
  dataBasedOnEventId() {
    this.dataEvent = [{
      "eventId": this.eventId,
      "taskJobId": this.taskJobId,
      "taskId": this.taskId,
      "taskScheduledId": this.taskScheduledId,
      "taskName": this.taskName,
      "userId": this.userName,
      "status": this.status,
      "serverName": this.serverName,
      "eventDate": this.eventDate,
      "message": this.message,
      "userName": this.userName,
      "timeInUK": this.timeInUk,
      "timeInEdtEst": this.timeInEdtEst,
    }]

  }
  viewJobId(id: any) {
    this.task = false
    this.scheduled = false
    this.view = true
    this.scheduleUpdate = false
    this.viewEvent = false

    const request = {
      "command": "drillByTaskJobId",
      "taskJobId": id,

    }

    this.service.viewRunHistory(request).subscribe((data) => {
      this.viewJobIdData = data
      this.viewtaskScheduledId = this.viewJobIdData[0].taskScheduledId
      this.viewtaskJobId = this.viewJobIdData[0].taskJobId
      this.viewtaskId = this.viewJobIdData[0].taskId
      this.viewtaskName = this.viewJobIdData[0].taskName

    })
    const req = {
      "command": "search",
      "taskScheduledId": this.viewtaskScheduledId,
      "taskJobId": id,
      "taskId": this.viewtaskId,
      "taskName": this.viewtaskName,
      "status": this.viewstatus,
      "startDate": this.datePipe.transform(this.viewstartDate, 'yyyy-MM-dd'),
      "endDate": this.datePipe.transform(this.viewendDate, 'yyyy-MM-dd'),
      "eventId": 0
    }
    this.service.viewRunHistory(req).subscribe((data) => {
      this.viewRun = data

      if (this.viewRun.length == 0) {
        this.errorMsg = true
      }
      else {
        this.errorMsg = false
      }
    })
  }
  viewByEventId(eventid: any) {

    this.viewEvent = true
    this.task = false;
    this.scheduled = false;
    this.view = false;
    this.show = false;
    const request = {
      "command": "drillByEventId",
      "taskScheduledId": this.viewtaskScheduledId,
      "taskJobId": this.viewtaskJobId,
      "taskId": this.viewtaskId,
      "taskName": this.viewtaskName,
      "status": this.viewstatus,
      "startDate": this.datePipe.transform(this.viewstartDate, 'yyyy-MM-dd'),
      "endDate": this.datePipe.transform(this.viewendDate, 'yyyy-MM-dd'),
      "eventId": eventid
    }
    this.service.viewRunHistory(request).subscribe((data) => {
      this.viewEventIdData = data

      this.viewByEventId_EventId = this.viewEventIdData[0].eventId
      this.viewByEventId_JobId = this.viewEventIdData[0].taskJobId
      this.viewByEventId_ScheduleId = this.viewEventIdData[0].taskScheduledId
      this.viewByEventId_Id = this.viewEventIdData[0].taskId
      this.viewByEventId_taskName = this.viewEventIdData[0].taskName
      this.viewByEventId_user = this.viewEventIdData[0].userId
      this.viewByEventId_timeUk = this.viewEventIdData[0].timeInUK
      this.viewByEventId_timeEst_Edt = this.viewEventIdData[0].timeInEdtEst
      this.viewByEventId_status = this.viewEventIdData[0].status
      this.viewByEventId_server = this.viewEventIdData[0].serverName
      this.viewByEventId_message = this.viewEventIdData[0].message

    })
  }
  addScheduleTask() {
    if (this.dropDown == undefined || this.dropDown == "") {
      alert(this.translate.instant('taskSelect'));

    }
    else {
      this.scheduleAdd = true;
      this.viewEvent = false;
      this.task = false;
      this.scheduled = false;
      this.view = false;
      this.show = false;
      this.scheduleUpdate = false;
      this.taskIdAdd = this.viewObj[0].taskId
      this.taskNameAdd = this.viewObj[0].taskClassSimpleName
    }
  }

  addSchedule() {
    const request = {

      "taskName": this.taskNameAdd,
      "pattern": this.pattern,
      "serverName": this.server,
      "enabled": this.enable,
      "userId": this.userName1,
      "taskId": this.taskIdAdd,
    }
    let c = this.pattern.split(" ")
    let a = c[0].split("/")
    if (c[1] != undefined) {
      var b = c[1].split("/")
    }

    if (c[2] != undefined) {

      var d = c[2].split("/")
    }
    if (this.pattern == undefined || this.pattern == "") {
      alert(this.translate.instant('missingFields'));

    }
    else if (c.length != 6) {
      this.errMsg = true;
    }
    else if (!(((c[0] >= 0 && c[0] <= 59) || c[0] == '*') ||
      (a.length == 2 && (((a[0] >= 0 && a[0] <= 59) || a[0] == '*')) &&
        (((a[1] >= 0 || a[1] <= 59) || a[1] == '*'))))) {
      this.errMsg = true;

    }

    else if (!(((c[1] >= 0 && c[1] <= 59) || c[1] == '*') ||
      (b.length == 2 && (((b[0] >= 0 && b[0] <= 59) || b[0] == '*')) &&
        (((b[1] >= 0 || b[1] <= 59) || b[1] == '*'))))) {
      this.errMsg = true;
    }
    else if (!(((c[2] >= 0 && c[2] <= 23) || c[2] == '*') ||
      (d.length == 2 && (((d[0] >= 0 && d[0] <= 23) || d[0] == '*')) &&
        (((d[1] >= 0 || d[1] <= 23) || d[1] == '*'))))) {
      this.errMsg = true;
    }
    else if (!((c[3] >= 1 && c[3] <= 31) || (c[3] == '*') || (c[3] == "L"))) {
      this.errMsg = true;
    }
    else if (!((c[4] >= 1 && c[4] <= 12) || c[4] == '*' || c[4] == "jan" || c[4] == "feb" || c[4] == "mar" || c[4] == "apr" || c[4] == "may" || c[4] == "jun" || c[4] == "jul" || c[4] == "aug" || c[4] == "sep" || c[4] == "oct" || c[4] == "nov" || c[4] == "dec")) {
      this.errMsg = true;

    }
    else if (c[5] == "") {
      this.errMsg = true;
    }
    else if (!((c[5] >= 0 && c[5] <= 6) || c[5] == '*' || c[5] == "sun" || c[5] == "mon" || c[5] == "tue" || c[5] == "wed" || c[5] == "thu" || c[5] == "fri" || c[5] == "sat")) {
      this.errMsg = true;

    }
    else {
      this.errMsg = false;

      this.service.updateScheduledTask(request).subscribe(data => { 
      this.scheduleGetCall();
      this.scheduledClick();
    })
    }
    this.service.getAllScheduleTask().subscribe(data => {
      this.allScheduleTask = data
    })
  }
  scheduleUpdateSubmit() {
    this.viewScheduleUpdate = [{
      "id": this.scheduleTaskIdUpdate,
      "taskId": this.taskIdAdd,
      "taskName": this.taskNameAdd,
      "pattern": this.updatePattern,
      "serverName": this.updateServer

    }]

  }
  scheduleUpdateView(id: any, taskId: any, taskName: any, pattern: any, serverName: any) {
    this.scheduleTaskIdUpdate = id
    this.taskIdAdd = taskId
    this.taskNameAdd = taskName
    this.updatePattern = pattern
    this.updateServer = serverName
    this.serverNameUpdate = serverName
    this.scheduleUpdateSubmit()
    this.scheduleUpdate = true;
    this.scheduleAdd = false;
    this.viewEvent = false;
    this.task = false;

    this.scheduled = false;
    this.view = false;
    this.show = false;

  }
  enabled() {
    this.enable = !this.enable
  }
  navigateHistory(id: any, taskId: any, name: any) {
    this.task = false;
    this.scheduled = false;
    this.view = true;
    this.show = false;
    this.viewEvent = false;
    this.scheduleUpdate = false
    this.viewtaskScheduledId = id
    this.viewtaskId = taskId,
    this.viewstartDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd')
    this.viewtaskName = name
    this.viewstatus = null
    this.viewendDate = ""
    this.viewRunHistory()
  }
  historyNavigate(id: any, name: any) {
    this.task = false;
    this.scheduled = false;
    this.view = true;
    this.show = false;
    this.viewEvent = false;
    this.scheduleUpdate = false
    this.viewtaskScheduledId =""
    this.viewendDate = ""
    this.viewtaskId = id,
    this.viewtaskName = name
    this.viewstartDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd')
    this.viewstatus = null
    this.viewRunHistory()
  }
  updateSchedule() {


    const request = {
      "id": this.scheduleTaskIdUpdate,
      "taskId": this.taskIdAdd,
      "taskName": this.taskNameAdd,
      "pattern": this.updatePattern,
      "serverName": this.updateServer,
      "enabled": this.enable,
      "userId": this.userName1
    }
    let c = this.updatePattern.split(" ")
    let a = c[0].split("/")
    if (c[1] != undefined) {
      var b = c[1].split("/")
    }

    if (c[2] != undefined) {

      var d = c[2].split("/")
    }
    if (this.updatePattern == undefined || this.updatePattern == "") {
      alert(this.translate.instant('missingFields'));

    }
    else if (c.length != 6) {
      this.errMsg = true;
    }
    else if (!(((c[0] >= 0 && c[0] <= 59) || c[0] == '*') ||
      (a.length == 2 && (((a[0] >= 0 && a[0] <= 59) || a[0] == '*')) &&
        (((a[1] >= 0 || a[1] <= 59) || a[1] == '*'))))) {
      this.errMsg = true;

    }

    else if (!(((c[1] >= 0 && c[1] <= 59) || c[1] == '*') ||
      (b.length == 2 && (((b[0] >= 0 && b[0] <= 59) || b[0] == '*')) &&
        (((b[1] >= 0 || b[1] <= 59) || b[1] == '*'))))) {
      this.errMsg = true;
    }
    else if (!(((c[2] >= 0 && c[2] <= 23) || c[2] == '*') ||
      (d.length == 2 && (((d[0] >= 0 && d[0] <= 23) || d[0] == '*')) &&
        (((d[1] >= 0 || d[1] <= 23) || d[1] == '*'))))) {
      this.errMsg = true;
    }
    else if (!((c[3] >= 1 && c[3] <= 31) || (c[3] == '*') || (c[3] == "L"))) {
      this.errMsg = true;
    }
    else if (!((c[4] >= 1 && c[4] <= 12) || c[4] == '*' || c[4] == "jan" || c[4] == "feb" || c[4] == "mar" || c[4] == "apr" || c[4] == "may" || c[4] == "jun" || c[4] == "jul" || c[4] == "aug" || c[4] == "sep" || c[4] == "oct" || c[4] == "nov" || c[4] == "dec")) {
      this.errMsg = true;

    }
    else if (!((c[5] >= 0 && c[5] <= 6) || c[5] == '*' || c[5] == "sun" || c[5] == "mon" || c[5] == "tue" || c[5] == "wed" || c[5] == "thu" || c[5] == "fri" || c[5] == "sat")) {
      this.errMsg = true;

    }
    else {
      this.errMsg = false;
      this.service.updateScheduledTask(request).subscribe(data => { 
      this.scheduleGetCall();
      this.scheduledClick();
    })
    }
    this.service.getAllScheduleTask().subscribe(data => {
      this.allScheduleTask = data})
  }
  deleteSchedule(task: any) {
    const request = {
      "id": task.id
    }

    this.service.deleteScheduledTask(request).subscribe(data => { })

    this.service.getAllScheduleTask().subscribe(data => {
      this.allScheduleTask = data

    })
    this.scheduledClick()
  }


}
